import { useEffect, useState } from "react";
import { LAUNCH_AT, now } from "../../lib/clock";
import { scrollToId } from "../../lib/content";

const pad = (n) => String(n).padStart(2, "0");

const split = (ms) => ({
  days: Math.floor(ms / 86400000),
  hours: Math.floor((ms % 86400000) / 3600000),
  minutes: Math.floor((ms % 3600000) / 60000),
});

const Unit = ({ value, label, testId }) => (
  <span className="flex items-baseline gap-1">
    <span data-testid={testId} className="font-serif text-2xl sm:text-4xl font-light tabular-nums text-[#FDFBF7]">{pad(value)}</span>
    <span className="text-[0.7rem] sm:text-sm text-[#F2C98F]">{label}</span>
  </span>
);

const StoreButton = ({ url, label, primary, testId }) => {
  const cls = primary ? "btn-primary justify-center" : "btn-ghost-light";
  if (url) return <a href={url} target="_blank" rel="noopener noreferrer" data-testid={testId} className={cls}>{label}</a>;
  return <button type="button" onClick={() => scrollToId("waitlist")} data-testid={testId} className={cls}>{label}</button>;
};

const Launched = ({ links }) => (
  <div data-testid="hero-launched" className="fade-up mt-5">
    <p data-testid="hero-launched-title" className="font-serif text-3xl sm:text-4xl text-[#FDFBF7]">Woven is here!</p>
    <div className="mt-5 flex flex-col sm:flex-row gap-3">
      <StoreButton url={links.ios_url} label="Download on the App Store" primary testId="hero-app-store-button" />
      <StoreButton url={links.android_url} label="Get it on Google Play" testId="hero-google-play-button" />
    </div>
  </div>
);

export const Countdown = ({ links }) => {
  const [t, setT] = useState(now);
  useEffect(() => {
    const id = setInterval(() => setT(now()), 1000);
    return () => clearInterval(id);
  }, []);

  const left = LAUNCH_AT - t;
  if (left <= 0) return <Launched links={links} />;
  const { days, hours, minutes } = split(left);
  return (
    <div data-testid="hero-countdown" className="fade-up mt-5 inline-flex max-w-full flex-col gap-2 self-start rounded-2xl border border-[#FDFBF7]/15 bg-[#FDFBF7]/10 px-4 sm:px-5 py-3.5 backdrop-blur-md" style={{ animationDelay: "160ms" }}>
      <p data-testid="hero-countdown-label" className="text-[0.7rem] sm:text-xs uppercase tracking-[0.22em] text-[#F4EBDD]/85">Woven arrives Christmas Eve</p>
      <div className="flex flex-wrap items-baseline gap-x-2 sm:gap-x-3 gap-y-1" aria-live="off">
        <Unit value={days} label="Days" testId="countdown-days" />
        <span className="text-[#F2C98F]/70">·</span>
        <Unit value={hours} label="Hours" testId="countdown-hours" />
        <span className="text-[#F2C98F]/70">·</span>
        <Unit value={minutes} label="Minutes" testId="countdown-minutes" />
      </div>
    </div>
  );
};
